/*
 * Clara quiz modal — our own responsive dialog.
 * Build: 2026-09-02-quiz-modal-r9
 *
 * Opens the Clara quiz in an iframe that always fills the modal. Sizing is
 * decided by the device (full-screen sheet on mobile, centred dialog on
 * desktop) — never by height messages from inside the iframe.
 *
 * Usage: any link/button with href="#open-quiz" or [data-clara-quiz] opens it.
 * Optional overrides on window.CLARA_QUIZ_CONFIG = { origin, params }.
 */
(function () {
  if (window.__claraQuizModal) return;

  var CFG = window.CLARA_QUIZ_CONFIG || {};
  var ORIGIN = CFG.origin || 'https://practitioners.metabolics.com';
  var TRACK_URL = window.__CLARA_TRACK_URL || 'https://hscadcshumjwpbykirdu.supabase.co/functions/v1/clara-public-track';
  var ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhzY2FkY3NodW1qd3BieWtpcmR1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTc2MTUyMDYsImV4cCI6MjA3MzE5MTIwNn0.bT-A3BJzHNXAhUuT__L7Iqf6p0FTjjP82MIdFZdVYb0';
  var PARAMS = CFG.params || 'embed=1&utm_source=shopify&utm_medium=popup';
  var URL_ = ORIGIN + '/clara-quiz?' + PARAMS;

  var STYLE = [
    '.clara-qm{position:fixed;inset:0;z-index:2147483647;display:none}',
    '.clara-qm.is-open{display:block}',
    '.clara-qm__overlay{position:absolute;inset:0;background:rgba(13,34,56,.55);backdrop-filter:blur(2px)}',
    '.clara-qm__dialog{position:absolute;background:#faf6f8;overflow:hidden;display:flex;flex-direction:column;',
    'box-shadow:0 24px 70px rgba(13,34,56,.35)}',
    /* mobile: full-screen sheet */
    '.clara-qm__dialog{inset:0;border-radius:0}',
    '@media (min-width:768px){.clara-qm__dialog{inset:auto;top:50%;left:50%;transform:translate(-50%,-50%);',
    'width:min(720px,94vw);height:min(88vh,900px);border-radius:20px}}',
    '.clara-qm__close{position:absolute;top:10px;right:10px;z-index:2;width:36px;height:36px;border-radius:999px;',
    'border:1px solid rgba(13,34,56,.12);background:#fff;color:#0d2238;font-size:18px;line-height:1;cursor:pointer;',
    'display:flex;align-items:center;justify-content:center}',
    '.clara-qm__close:hover{background:#f3ecef}',
    '.clara-qm__frame{flex:1 1 auto;width:100%;height:100%;border:0;display:block;background:#faf6f8}',
    'body.clara-qm-locked{overflow:hidden!important}',
    /* The Clara launcher sits at a higher stacking level than most theme UI and
       would otherwise float over the quiz sheet on mobile, where a tap on it
       closed the quiz and opened the chat instead. Hide it while the quiz is open. */
    'body.clara-qm-locked .clara-bubble,body.clara-qm-locked #clara-care-bubble{display:none!important;pointer-events:none!important}'
  ].join('');

  var root, frame, lastFocus;

  function build() {
    var s = document.createElement('style');
    s.textContent = STYLE;
    document.head.appendChild(s);

    root = document.createElement('div');
    root.className = 'clara-qm';
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-label', 'Clara supplement quiz');
    root.innerHTML =
      '<div class="clara-qm__overlay" data-close="1"></div>' +
      '<div class="clara-qm__dialog">' +
      '<button type="button" class="clara-qm__close" aria-label="Close quiz" data-close="1">&times;</button>' +
      '<iframe class="clara-qm__frame" title="Clara quiz" allow="clipboard-write" referrerpolicy="no-referrer-when-downgrade"></iframe>' +
      '</div>';
    document.body.appendChild(root);
    frame = root.querySelector('.clara-qm__frame');

    root.addEventListener('click', function (e) {
      var t = e.target;
      if (t && t.getAttribute && t.getAttribute('data-close')) close();
    });
  }

  function setVh() {
    // 100dvh fallback for older mobile browsers.
    if (root) root.style.setProperty('--clara-vh', window.innerHeight + 'px');
  }

  var identityAcked = false;
  var identityTimer = null;

  function readIdentity() {
    var email = null, firstName = null, id = null;
    try {
      if (typeof window.__claraIdentity === 'function') {
        var shared = window.__claraIdentity();
        if (shared && (shared.email || shared.id)) return shared;
      }
      var sh = window.__CLARA_SHOPIFY || {};
      var cfg = window.ClaraConfig || {};
      email = sh.customer_email || cfg.customerEmail || null;
      firstName = sh.customer_first_name || cfg.customerFirstName || null;
      id = sh.customer_id || cfg.customerId || null;
      if (!id && window.__st && window.__st.cid) id = String(window.__st.cid);
      var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
      if (!id && meta && meta.page && meta.page.customerId) id = String(meta.page.customerId);
      if (!id && window.Shopify && window.Shopify.customerId) id = String(window.Shopify.customerId);
      if (!email && !id) {
        // A server-rendered theme with no customer means signed out: drop cache.
        if (window.ClaraConfig || window.__CLARA_SHOPIFY) {
          try { localStorage.removeItem('clara_identity'); } catch (e) {}
        } else {
          var stored = null;
          try { stored = JSON.parse(localStorage.getItem('clara_identity') || 'null'); } catch (e) {}
          if (stored) { email = stored.email || null; firstName = stored.first_name || null; id = stored.id || null; }
        }
      } else {
        try { localStorage.setItem('clara_identity', JSON.stringify({ email: email, first_name: firstName, id: id })); } catch (e) {}
      }
    } catch (e) {}
    if (!email && !id) return null;
    return { email: email, first_name: firstName, id: id ? String(id) : null };
  }

  function sharedAnonId() {
    try {
      if (typeof window.__claraAnonId === 'function') return window.__claraAnonId();
      var id = localStorage.getItem('clara_anon_id') || localStorage.getItem('clara_public_anon_id');
      if (!id) id = crypto.randomUUID();
      localStorage.setItem('clara_anon_id', id);
      localStorage.setItem('clara_public_anon_id', id);
      return id;
    } catch (e) { return null; }
  }

  // Where the quiz was opened from, so analytics can compare the homepage
  // block, the Clara chat banner, product pages and so on.
  var launch = { source: 'unknown', label: null, page: null, page_type: null };

  function pageType() {
    try {
      var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
      if (meta && meta.page && meta.page.pageType) return String(meta.page.pageType);
    } catch (e) {}
    return null;
  }

  function resolveSource(el) {
    var source = null, label = null;
    try {
      if (el) {
        var tagged = el.closest('[data-quiz-source]');
        if (tagged) source = tagged.getAttribute('data-quiz-source');
        label = (el.textContent || '').trim().slice(0, 80) || null;
        if (!source) {
          if (el.closest('[data-clara-quizbanner],.clara-quizbanner')) source = 'clara_chat_banner';
          else if (el.closest('.clara-hero')) source = 'homepage_clara_block';
          else if (el.closest('[data-clara-sticky-bar],.mbx-sticky-buy-bar')) source = 'product_sticky_bar';
          else {
            var section = el.closest('[id^="shopify-section-"]');
            if (section) source = 'section:' + section.id.replace('shopify-section-', '').replace(/^template--\d+__/, '');
          }
        }
      }
    } catch (e) {}
    return {
      source: source || 'unknown',
      label: label,
      page: (location.pathname || null),
      page_type: pageType()
    };
  }

  function submitQuizEvent(d) {
    var id = sharedAnonId();
    if (!id) return Promise.reject(new Error('missing_session'));
    return fetch(TRACK_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', apikey: ANON_KEY, Authorization: 'Bearer ' + ANON_KEY },
      body: JSON.stringify({
        event_type: d.event_type,
        anon_id: id,
        payload: Object.assign({}, d.payload || {}, {
          surface: 'quiz',
          launch_source: launch.source,
          launch_label: launch.label,
          launch_page: launch.page,
          launch_page_type: launch.page_type
        }),
        shopify_customer: readIdentity(),
        referrer: location.href,
        utm: d.utm && typeof d.utm === 'object' ? d.utm : null
      }),
      keepalive: true
    }).then(function (response) {
      if (!response.ok) throw new Error('track_' + response.status);
      return { anon_id: id, identified: !!readIdentity() };
    });
  }


  // Belt and braces: carry identity in the iframe URL too, so a missed
  // postMessage handshake cannot make a signed-in shopper look anonymous.
  function frameUrl() {
    var url = URL_;
    var who = readIdentity();
    var sharedAnonId = null;
    try {
      sharedAnonId = typeof window.__claraAnonId === 'function'
        ? window.__claraAnonId()
        : (localStorage.getItem('clara_anon_id') || localStorage.getItem('clara_public_anon_id'));
    } catch (e) {}
    if (sharedAnonId) url += (url.indexOf('?') === -1 ? '?' : '&') + 'caid=' + encodeURIComponent(sharedAnonId);
    if (who) {
      var q = [];
      if (who.email) q.push('cem=' + encodeURIComponent(who.email));
      if (who.first_name) q.push('cfn=' + encodeURIComponent(who.first_name));
      if (who.id) q.push('cid=' + encodeURIComponent(who.id));
      if (q.length) url += (url.indexOf('?') === -1 ? '?' : '&') + q.join('&');
    }
    // Signed identity rendered by clara-quiz-cta.liquid: lets the quiz verify
    // the shopper server-side and pre-fill recent supplements.
    try {
      var auth = window.__CLARA_QUIZ_AUTH;
      if (auth && auth.email && auth.ts && auth.sig) {
        url += (url.indexOf('?') === -1 ? '?' : '&')
          + 'email=' + encodeURIComponent(auth.email)
          + '&ts=' + encodeURIComponent(auth.ts)
          + '&sig=' + encodeURIComponent(auth.sig);
      }
    } catch (e) {}
    return url;
  }

  function sendCustomerIdentity() {
    if (!frame || !frame.contentWindow) return;
    var customer = readIdentity();
    if (!customer) return;
    try {
      frame.contentWindow.postMessage({ type: 'clara-shopify-customer', customer: customer }, ORIGIN);
    } catch (e) {}
  }

  // Keep offering identity until the quiz acknowledges it: a single post on
  // load races the iframe's own React bootstrap and is often missed.
  function startIdentityHandshake(force) {
    if (identityTimer && !force) return;
    if (identityTimer) clearInterval(identityTimer);
    identityTimer = null;
    identityAcked = false;
    var attempts = 0;
    sendCustomerIdentity();
    identityTimer = setInterval(function () {
      attempts += 1;
      if (identityAcked || attempts > 20) {
        clearInterval(identityTimer);
        identityTimer = null;
        return;
      }
      sendCustomerIdentity();
    }, 300);
  }

  function open(customer) {
    if (!root) build();
    if (customer && (customer.email || customer.id)) {
      try { localStorage.setItem('clara_identity', JSON.stringify(customer)); } catch (e) {}
    }
    // The modal and iframe can survive a Shopify logout/login round-trip via
    // the browser's back-forward cache. Clara resolves identity on every chat
    // turn, so do the same here instead of reusing an iframe URL carrying an
    // old anonymous session. Reload only when the session or customer changed.
    var nextUrl = frameUrl();
    var currentUrl = frame.getAttribute('src') || '';
    if (currentUrl !== nextUrl) {
      frame.setAttribute('src', nextUrl);
    }
    // An already-loaded iframe does not emit another load event when reopened.
    // Restart the handshake explicitly every time the shopper opens the quiz.
    startIdentityHandshake(true);
    lastFocus = document.activeElement;
    root.classList.add('is-open');
    document.body.classList.add('clara-qm-locked');
    setVh();
    var btn = root.querySelector('.clara-qm__close');
    if (btn) btn.focus();
  }

  function close() {
    if (!root) return;
    root.classList.remove('is-open');
    document.body.classList.remove('clara-qm-locked');
    try { if (lastFocus && lastFocus.focus) lastFocus.focus(); } catch (e) {}
  }

  // Belt and braces: if an older cached embed still renders the launcher,
  // never let a tap on it reach Clara while the quiz sheet is open.
  document.addEventListener('click', function (e) {
    if (!root || !root.classList.contains('is-open')) return;
    var b = e.target && e.target.closest ? e.target.closest('.clara-bubble,#clara-care-bubble') : null;
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
  }, true);

  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('a[href="#open-quiz"],a[href$="#open-quiz"],[data-clara-quiz],[data-clara-quizbanner],.open-quiz') : null;
    if (!el) return;
    e.preventDefault();
    launch = resolveSource(el);
    try { submitQuizEvent({ event_type: 'quiz_opened', payload: {} }); } catch (err) {}
    open();
  });

  window.addEventListener('message', function (e) {
    if (e.data && e.data.type === 'clara:open-quiz') {
      launch = { source: e.data.source || 'clara_chat', label: e.data.label || null, page: location.pathname || null, page_type: pageType() };
      try { submitQuizEvent({ event_type: 'quiz_opened', payload: {} }); } catch (err) {}
      open(e.data.customer || null);
    }
  });


  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root && root.classList.contains('is-open')) close();
  });

  window.addEventListener('resize', setVh);

  window.addEventListener('message', function (e) {
    if (String(e.origin).indexOf(ORIGIN) !== 0) return;
    var d = e.data || {};
    if (d.type === 'clara-quiz-close') close();
  });

  window.addEventListener('message', function (e) {
    if (e.origin !== ORIGIN || !frame || e.source !== frame.contentWindow) return;
    if (!e.data) return;
    if (e.data.type === 'clara-quiz-ready') startIdentityHandshake(false);
    if (e.data.type === 'clara-quiz-customer-ack') identityAcked = true;
    if (e.data.type === 'clara-quiz-track') {
      var d = e.data;
      var allowed = typeof d.event_type === 'string' && (d.event_type.indexOf('quiz_') === 0 || d.event_type === 'plan_emailed');
      if (!allowed || typeof d.request_id !== 'string') return;
      submitQuizEvent(d).then(function (result) {
        e.source.postMessage({ type: 'clara-quiz-track-ack', request_id: d.request_id, ok: true, anon_id: result.anon_id, identified: result.identified }, e.origin);
      }).catch(function () {
        e.source.postMessage({ type: 'clara-quiz-track-ack', request_id: d.request_id, ok: false }, e.origin);
      });
    }
  });

  window.__claraQuizModal = { open: open, close: close };
})();
